const pickString = (value: unknown): string => {
  if (value == null) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "number" && !Number.isNaN(value)) return String(value).trim();
  return "";
};

const fromNestedCompany = (company: unknown): string => {
  if (!company || typeof company !== "object") return "";
  const c = company as Record<string, unknown>;
  return (
    pickString(c.company_name) ||
    pickString(c.companyName) ||
    pickString(c.name) ||
    pickString(c.organization_name) ||
    pickString(c.business_name) ||
    pickString(c.display_name)
  );
};

/**
 * Resolves employer display name from dashboard API payload.
 * Prefers organization/company fields over generic `name` (often subadmin login label).
 */
export const getCompanyDisplayName = (
  companyData?: Record<string, unknown> | null
): string => {
  if (!companyData) return "";

  const candidates: unknown[] = [
    companyData.company_name,
    companyData.companyName,
    companyData.organization_name,
    companyData.business_name,
    companyData.display_name,
    companyData.employer_name,
    companyData.subadmin_company_name,
    fromNestedCompany(companyData.company),
    fromNestedCompany(companyData.organization),
    fromNestedCompany(companyData.subadmin),
    companyData.name,
    typeof companyData.company === "string" ? companyData.company : null,
  ];

  for (const value of candidates) {
    const trimmed = pickString(value);
    if (trimmed) return trimmed;
  }

  return "";
};
